import styled, { css } from 'styled-components';
import { animationPresets } from '@styles/animations';

export const AnimatedElement = styled.div<{
  $animationType?: keyof typeof animationPresets;
  $delay?: number;
}>`
  opacity: 0;
  ${({ $animationType = 'fadeIn', $delay = 0 }) => css`
    &.animate-in {
      ${animationPresets[$animationType]}
      animation-delay: ${$delay}s;
    }
  `}
`;
